import { MarkdownPage } from '@saas/markdown/markdownPage'

/**
 * Applies a few rendering customizations to the markdown specific to blog posts.
 */
export class BlogMarkdownPage extends MarkdownPage {
  beforeRender() {
    this.wrapImages(this.parsed)
    this.markdownIt.renderer.rules.image =
      this.wrapImagesAndConvertVideosRule.bind(this)
  }

  /**
   * Recursively searches for images in the tokens and applies baserow
   * specific css to them.
   */
  wrapImages(tokens) {
    tokens.forEach((token) => {
      if (token.type === 'image') {
        this.setTokenAttribute(token, 'class', 'blog-post__image-source')
        this.setTokenAttribute(token, 'alt', token.content)
        this.setTokenAttribute(token, 'loading', 'lazy')
      }

      // Recursively check if there are children that need to be updated.
      if (token.children !== null) {
        this.wrapImages(token.children)
      }
    })
  }

  /**
   * Markdown it rule override which will wrap images with a styled div or convert mp4
   * 'images' to a html5 video player.
   */
  wrapImagesAndConvertVideosRule(tokens, idx, options, env, self) {
    if (tokens.length > 0 && tokens[0].type === 'image') {
      const imageToken = tokens[0]
      const imageUrl = this.getTokenAttribute(imageToken, 'src')
      if (imageUrl.endsWith('mp4')) {
        return `<div class="blog-post__image">
        <video class="blog-post__image-source" controls="controls">
          <source
            src="${imageUrl}"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>`
      }
    }
    return (
      "<div class='blog-post__image'>" +
      self.renderToken(tokens, idx, options) +
      '</div>'
    )
  }
}
